// extracted by mini-css-extract-plugin
export default {"normal":"button_normal__K+Gy4","selected":"button_selected__yR6W9","off":"button_off__Eq-Tu"};